import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputFieldLabelModule } from '../input-field-label/input-field-label.module';
import { InputTextareaComponent } from './input-textarea.component';

@NgModule({
  declarations: [InputTextareaComponent],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    InputFieldLabelModule
  ],
  exports: [InputTextareaComponent],
})
export class InputTextareaModule { }
